// icons.tsx (create this helper to keep imports tidy)
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import HomeRepairServiceOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

export const Icons = {
  Dashboard: SpaceDashboardOutlinedIcon,
  Users: GroupOutlinedIcon,
  Permission: AdminPanelSettingsOutlinedIcon,
  Roles: VerifiedUserOutlinedIcon,
  Customers: PeopleAltOutlinedIcon,
  ProgramModule: WidgetsOutlinedIcon,
  ManageClients: BusinessOutlinedIcon,
  ManagePlans: AutoAwesomeMosaicOutlinedIcon,
  ManageBCC: EmailOutlinedIcon,
  ServiceGrouping: CategoryOutlinedIcon,
  SubServices: HomeRepairServiceOutlinedIcon,
  ServiceCategories: ViewListOutlinedIcon,
  SubCategories: ListAltOutlinedIcon,
  Commercials: AttachMoneyOutlinedIcon,
  Blogs: ArticleOutlinedIcon,
  Products: ShoppingBagOutlinedIcon,
  ManageVendors: StorefrontOutlinedIcon,
  FormManagement: DescriptionOutlinedIcon,
  CommunicationConfig: ChatBubbleOutlineOutlinedIcon
};
